import React from 'react';
import PropTypes from 'prop-types';
import { CustomizableButton, ButtonGroup } from '~components/common/Button';
import { navigate } from 'gatsby-link';

function TipJar({ headline, content, noThanksPath, variant, tool }) {
  const expressDonationWarning =
    'If you have saved your payment information with ActBlue Express, your donation will go through immediately.';

  const handleDonationclick = () => {
    navigate(noThanksPath);
  };

  return (
    <div className='w-full rounded bg-base-200 p-6 md:p-12'>
      <h1>{headline}</h1>
      <p>{content}</p>
      <p className='text-sm'>{expressDonationWarning}</p>
      <div className='flex flex-col gap-7 md:flex-row'>
        <ButtonGroup>
          <CustomizableButton
            href={`https://secure.actblue.com/donate/tipjar?express_lane=true&amount=3&refcode=express_lane_3_${tool}`}
            state={{ variant }}
            onClick={handleDonationclick}
            elementType='a'
            target='_blank'
            rel='noopener'
          >
            Express Donate $3
          </CustomizableButton>
          <CustomizableButton
            href={`https://secure.actblue.com/donate/tipjar?express_lane=true&amount=9&refcode=express_lane_9_${tool}`}
            state={{ variant }}
            onClick={handleDonationclick}
            elementType='a'
            target='_blank'
            rel='noopener'
          >
            Express Donate $9
          </CustomizableButton>
          <CustomizableButton
            href={`https://secure.actblue.com/donate/tipjar?express_lane=true&amount=15&refcode=express_lane_15_${tool}`}
            state={{ variant }}
            onClick={handleDonationclick}
            elementType='a'
            target='_blank'
            rel='noopener'
          >
            Express Donate $15
          </CustomizableButton>
        </ButtonGroup>
        <ButtonGroup>
          <CustomizableButton
            href={`https://secure.actblue.com/donate/tipjar?express_lane=true&amount=27&refcode=express_lane_27_${tool}`}
            state={{ variant }}
            onClick={handleDonationclick}
            elementType='a'
            target='_blank'
            rel='noopener'
          >
            Express Donate $27
          </CustomizableButton>
          <CustomizableButton
            href={`https://secure.actblue.com/donate/tipjar?express_lane_other=true&refcode=express_lane_other_${tool}`}
            state={{ variant }}
            onClick={handleDonationclick}
            elementType='a'
            target='_blank'
            rel='noopener'
          >
            Donate another amount
          </CustomizableButton>
          {noThanksPath && (
            <CustomizableButton
              isSecondary
              href={noThanksPath}
              state={{ variant }}
              elementType='a'
            >
              I can&apos;t donate today
            </CustomizableButton>
          )}
        </ButtonGroup>
      </div>
    </div>
  );
}

TipJar.propTypes = {
  headline: PropTypes.string,
  content: PropTypes.string,
  variant: PropTypes.string,
  noThanksPath: PropTypes.string,
  tool: PropTypes.string,
};

TipJar.defaultProps = {
  headline: 'Every $3 mobilizes 1 more voter',
  content:
    'No one mobilizes more voters per dollar spent than we do. Can you chip in to support our work?',
};

export default TipJar;

export function TipJarTool({ tool, headline, location, noThanksPath }) {
  return (
    <TipJar
      tool={tool}
      headline={headline}
      variant={location && location.state && location.state.variant}
      noThanksPath={noThanksPath}
    />
  );
}

TipJarTool.propTypes = {
  tool: PropTypes.string,
  headline: PropTypes.string,
  location: PropTypes.object,
  noThanksPath: PropTypes.string,
};
